import { render, staticRenderFns } from "./CathayFamilyDataTable.vue?vue&type=template&id=75c341a0&scoped=true"
import script from "./CathayFamilyDataTable.vue?vue&type=script&lang=js"
export * from "./CathayFamilyDataTable.vue?vue&type=script&lang=js"
import style0 from "./CathayFamilyDataTable.vue?vue&type=style&index=0&id=75c341a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c341a0",
  null
  
)

export default component.exports